module.exports = __webpack_public_path__ + "img/side-banner_store.7072c294.jpg";